<template>
  <div id="maps-page">
    <page-header-component
      v-if="topics"
      icon="bi bi-map"
      title="Maps"
      @filterChange="filterChange"
      :topics="topics"
      :hideValidate="false"
    />
    <div class="row">
      <div
        class="col-md-12 col-sm-12 col-xs-12 col-lg-12 mb-1 px-gap"
        v-if="display_tipe == 3"
      >
        <div
          id="tab"
          class="widget-12 card card-default widget-loader-circle shade"
        >
          <div class="card-body">
            <ul
              class="nav nav-tabs nav-tabs-simple d-md-flex d-lg-flex d-xl-flex"
              role="tablist"
              data-init-reponsive-tabs="dropdownfx"
            >
              <li
                class="nav-item"
                @click="switchTab('Medkon')"
                v-if="display_tipe == 2 || display_tipe == 3"
              >
                <a
                  class="active"
                  data-toggle="tab"
                  role="tab"
                  data-target="#tab2hellowWorld"
                  href="#"
                  aria-selected="true"
                >
                  <i class="bi bi-globe-americas" /> Media Konvensional
                </a>
              </li>
              <!-- <li
                class="nav-item"
                @click="switchTab('Medsos')"
                v-if="display_tipe == 1 || display_tipe == 3"
              >
                <a
                  href="#"
                  data-toggle="tab"
                  role="tab"
                  data-target="#tab2FollowUs"
                  class=""
                  aria-selected="false"
                >
                  <i class="bi bi-heart-fill text-danger" /> Media Sosial
                </a>
              </li> -->
            </ul>
          </div>
        </div>
      </div>
      <transition name="block">
        <div
          v-show="mounted"
          class="col-md-12 col-sm-12 col-xs-12 col-lg-12 mb-1 px-gap"
        >
          <div class="widget-12 card card-default widget-loader-circle shade">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <div class="pull-left m-t-5 m-b-5">
                    <h4 class="m-b-0">
                      {{ title_map }}
                    </h4>
                    <p class="small hint-text">
                      Peta sebaran mention per
                      {{ this.$route.query.from | date_time_to_indo }} hingga
                      {{ this.$route.query.to | date_time_to_indo }}
                    </p>
                  </div>
                  <div
                    class="pull-right m-t-20 d-flex align-items-center w-auto"
                  >
                    <multiselect
                      v-if="type_map == 'medkon'"
                      v-model="multiple_tier"
                      :options="tier_options"
                      :multiple="true"
                      :searchable="false"
                      placeholder="Semua Tier"
                      label="name"
                      track-by="name"
                      @input="filterTierChange"
                      class="ml-auto mr-2"
                      style="min-width: 15rem; width: max-content;"
                    >
                    </multiselect>
                    <!-- <div
                        class="form-group input-group input-group-right transparent m-b-0 m-t-0"
                        id="post-tier-filter"
                      >
                        <select
                          name="sort"
                          v-model="filter_tier"
                          @change="filterTierChange"
                          class="form-control form-custom"
                        >
                          <option value="0">Semua Tier</option>
                          <option value="1">Tier 1</option>
                          <option value="2">Tier 2</option>
                          <option value="3">Tier 3</option>
                          <option value="4">Tier 4</option>
                        </select>
                        <div class="input-group-append">
                          <span class="input-group-text transparent"
                            ><i class="bi bi-stack"
                          /></span>
                        </div>
                      </div> -->
                    <button
                      class="btn btn-success btn-lg"
                      @click="getDataExcel"
                    >
                      <i class="bi bi-filetype-xlsx mr-1"></i> Ekspor Data
                    </button>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <bubble-maps-component :key="data_key" :dataset="dataset" />
                  <div class="px-2" id="top-provinsi">
                    <div class="py-2" v-if="top_provinsi.length > 0">
                      <p class="h5 mb-3">
                        Top 10 Provinsi dengan Mention Terbanyak :
                      </p>
                      <div>
                        <div class="row">
                          <div
                            v-for="(prov, index) in top_provinsi"
                            :key="prov.nama_provinsi"
                            class="col-md-25"
                          >
                            <div class="shadow-sm rounded mb-2">
                              <div class="d-flex pt-1 px-2">
                                <span class="mr-auto h6 font-weight-bolder"
                                  >#{{ index + 1 }}
                                  {{ prov.nama_provinsi }}</span
                                >
                                <span class="ml-auto">{{
                                  thousandSeparator(prov.count)
                                }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="block">
        <div
          v-show="mounted"
          class="col-md-6 col-sm-12 col-xs-12 px-gap"
          id="popular-account"
        >
          <div class="card card-default shade">
            <div class="card-header separator">
              <div class="h6">
                Akun Terpopuler
                <span v-if="isShowProv">
                  Di <b>{{ current_prov_clicked }}</b>
                </span>
              </div>
            </div>
            <div class="card-body">
              <div v-if="isShowProv" class="table-unggahan-terbaru m-t-10">
                <table-dynamic-component
                  :key="table_key"
                  :data_head="data_head"
                  :data_head_class="data_head_class"
                  :data_body="akun_data"
                  :config="table_config"
                />
              </div>
              <p v-else class="m-t-10">
                Silahkan pilih salah satu provinsi pada peta terlebih dahulu
              </p>
            </div>
          </div>
        </div>
      </transition>
      <transition name="block">
        <div
          id="unggahan-terbaru"
          v-show="mounted"
          class="col-md-6 col-sm-12 col-xs-12 px-gap"
        >
          <div class="card card-default shade">
            <div class="card-header separator">
              <div class="h6">
                Unggahan Terbaru
                <span v-if="isShowProv">
                  Di <b>{{ current_prov_clicked }}</b>
                </span>
              </div>
            </div>
            <div class="card-body">
              <div v-if="isShowProv" class="table-unggahan-terbaru">
                <loader-component v-if="post_data == null" />
                <post-list-simple-component
                  v-else
                  :posts="post_data"
                  :key="post_key"
                  :string_limit="130"
                  :link="true"
                />
                <pagination-component
                  class="m-t-10 pull-right"
                  v-if="post_page_info"
                  :key="post_paging_key"
                  :data="post_page_info"
                />
              </div>
              <p v-else class="m-t-10">
                Silahkan pilih salah satu provinsi pada peta terlebih dahulu
              </p>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    ></v-tour>
  </div>
</template>

<script>
import $ from "jquery";
import page_header from "@/views/components/page_header.vue";
import bubble_maps_chart from "@/views/components/chart/bubble_maps_chart.vue";
import post_list_simple from "@/views/components/post_list_simple.vue";
import loader_component from "@/views/components/loader.vue";
import table_dynamic from "@/views/components/table_dynamic.vue";
import pagination from "@/views/components/pagination.vue";
import gp from "@/plugins/generalPlugins.js";
import provinsi from "@/plugins/new-id-all.js";
import Multiselect from "vue-multiselect";
import XLSX from "xlsx";
var table_config = {
  pageLength: 25,
  columnDefs: [{ width: "5%", targets: 0 }],
};
export default {
  name: "Maps",
  title: "Analytics Maps | Online Media Monitoring",
  components: {
    "page-header-component": page_header,
    "bubble-maps-component": bubble_maps_chart,
    "post-list-simple-component": post_list_simple,
    "loader-component": loader_component,
    "table-dynamic-component": table_dynamic,
    "pagination-component": pagination,
    Multiselect,
  },
  data() {
    return {
      multiple_tier: [],
      tier_options: [
        { name: "Tier 1", value: "1" },
        { name: "Tier 2", value: "2" },
        { name: "Tier 3", value: "3" },
        { name: "Tier 4", value: "4" },
      ],
      isShowProv: false,
      filter_tier: "0",
      dataset: null,
      current_prov_clicked: null,

      data_key: 0,
      table_key: 20,

      post_data: null,
      post_key: 10,

      akun_data: null,
      data_head:
        this.$store.getters.user.project.project_detail.display_tipe == 2 ||
        this.$store.getters.user.project.project_detail.display_tipe == 3
          ? ["No", "Media", "Berita"]
          : ["No", "Akun", "Followers", "Reach"],
      data_head_class: [
        {
          head: "No",
          class: "text-center",
        },
        {
          head: "Berita",
          class: "text-center",
        },
        {
          head: "Followers",
          class: "text-center",
        },
        {
          head: "Reach",
          class: "text-center",
        },
      ],
      table_config: table_config,
      akun_res: null,

      post_page_info: null,
      post_paging_key: 20,

      id_project: this.$store.getters.user.id_project,
      query: "",
      tooltip:
        "<p>Data yang ditampilkan pada maps hanya data dari twitter.</p>",

      filter_topic: this.$store.getters.filter_topic,
      topics: null,

      display_tipe: this.$store.getters.user.project.project_detail
        .display_tipe,
      tour_steps: [],

      mounted: false,
      type_map:
        this.$store.getters.user.project.project_detail.display_tipe == 2 ||
        this.$store.getters.user.project.project_detail.display_tipe == 3
          ? "medkon"
          : "medsos",
      title_map:
        this.$store.getters.user.project.project_detail.display_tipe == 2 ||
        this.$store.getters.user.project.project_detail.display_tipe == 3
          ? "Jumlah Mention Media Konvensional per Provinsi di Indonesia"
          : "Jumlah Mention Twitter per Provinsi di Indonesia",
      data_provinsi: [],
      top_provinsi: [],
      topKey: 0,
    };
  },
  methods: {
    filterTierChange() {
      const result = this.multiple_tier.map((item) => item.value).join(",");
      if (result) {
        this.filter_tier = result;
      } else {
        this.filter_tier = "0";
      }
      this.getData();
      this.getPost();
      this.getAkun();
    },
    switchTab: function(component) {
      this.dataset = [];
      if (component == "Medkon") {
        this.title_map =
          "Jumlah Mention Media Konvensional per Provinsi di Indonesia";
        this.type_map = "medkon";
        this.isShowProv = false;
        this.data_head = ["No", "Media", "Berita"];
      } else {
        this.title_map = "Jumlah Mention Twitter per Provinsi di Indonesia";
        this.type_map = "medsos";
        this.isShowProv = false;
        this.data_head = ["No", "Akun", "Followers", "Reach"];
      }
      this.getData();
      this.data_key++;
    },
    bubbleClicked: function(data) {
      this.current_prov_clicked = data.name;
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $("#popular-account").offset().top - 60,
        },
        1000
      );
      this.isShowProv = true;
      this.post_data = null;
      if ("page" in this.$route.query) {
        this.$route.query.page = 1;
      }
      this.getPost(data.hc_key);
      this.getAkun(data.hc_key);
    },
    getData: function() {
      var q = this.$route.query;
      let self = this;
      if ("from" in q) {
        let params = {
          from: this.$route.query.from,
          to: this.$route.query.to,
          tipesource: this.type_map,
        };
        if (this.type_map == "medkon") {
          params.tier = this.filter_tier;
        }
        if ("topic_selected" in this.$route.query) {
          params.topic_selected = this.$route.query.topic_selected;
        }
        if ("is_validated" in this.$route.query) {
          params.is_validated = this.$route.query.is_validated;
        }
        if ("cakupan" in this.$route.query) {
          params.cakupan = this.$route.query.cakupan;
        }
        if (this.filter_tier == "0") {
          delete params.tier;
        }
        let query = Object.keys(params)
          .map((key) => key + "=" + params[key])
          .join("&");
        if (query != this.query) {
          this.query = query;
          let api =
            process.env.VUE_APP_API_URL +
            "map/" +
            this.id_project +
            "?" +
            query;
          this.$http
            .get(api)
            .then((response) => {
              if (response.status == 200) {
                this.dataset = response.data;
              } else {
                this.dataset = [];
              }
              this.data_key++;
            })
            .catch(function(err) {
              console.log(err);
            })
            .finally(function() {
              self.getProvinsi();
            });
        }
      }
    },
    getPost: function(province) {
      var params = this.$route.query;
      params.tier = this.filter_tier;
      params.province = province;
      params.items = 10;
      params.sources =
        this.type_map == "medkon"
          ? btoa("news,media_tv,media_cetak")
          : btoa("twitter");

      if (this.filter_tier == "0") {
        delete params.tier;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api =
        process.env.VUE_APP_API_URL + "posts/" + this.id_project + "?" + query;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.post_data = response.data.posts;
          } else {
            this.post_data = [];
          }
          this.post_key++;

          this.post_page_info = response.data.page_info;
          this.post_paging_key++;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getAkun: function(province) {
      var params = this.$route.query;
      var paramsTypeSouce = this.type_map == "medkon" ? "/medkon?" : "/socmed?";
      params.province = province;
      params.items = 100;
      params.tier = this.filter_tier;
      if ("page" in params) {
        delete params.page;
      }
      if (this.filter_tier == "0") {
        delete params.tier;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      this.akun_data = null;
      this.table_key++;
      let api =
        process.env.VUE_APP_API_URL +
        "influencers/" +
        this.id_project +
        paramsTypeSouce +
        query;
      this.$http.get(api).then((response) => {
        if (response.status == 200) {
          this.akun_res = response.data.accounts;
          this.akun_data = [];
          for (let index in response.data.accounts) {
            let akun = "";
            if (this.type_map == "medkon") {
              akun =
                '<a class="source-akun-clicked" href="#" data-index="' +
                index +
                '" data-id="' +
                response.data.accounts[index]._id +
                '">' +
                response.data.accounts[index].account +
                "</a>";
              this.akun_data.push([
                `<center>${parseInt(index) + 1}</center>`,
                akun,
                `<center>${response.data.accounts[index].mentions}</center>`,
              ]);
            } else {
              akun =
                '<a class="source-akun-clicked" href="#" data-index="' +
                index +
                '" data-id="' +
                response.data.accounts[index]._id +
                '">@' +
                response.data.accounts[index].account +
                "</a>";
              this.akun_data.push([
                `<center>${parseInt(index) + 1}</center>`,
                akun,
                `<center>${response.data.accounts[index].followers}</center>`,
                `<center>${response.data.accounts[index].esmr}</center>`,
              ]);
            }
          }
          this.table_key++;
        } else {
          this.akun_data = [];
        }
      });
    },
    filterChange: function() {
      this.getData();
      if ("page" in this.$route.query && "province" in this.$route.query) {
        this.getPost(this.$route.query.province);
      }
    },
    getTopic: function() {
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.topics = response.data;
          } else {
            this.topics = {};
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.getData();
        });
    },
    showPost(index) {
      let account = this.akun_res[index];
      this.$router.push({
        path: "/detail-akun",
        query: { account: account.account, key: btoa(account._id) },
      });
    },
    getProvinsi: function() {
      let prov = provinsi.load_data();
      this.data_provinsi = [];
      this.top_provinsi = [];
      for (let feature in prov.features) {
        for (let data in this.dataset) {
          if (
            this.dataset[data].hc_key ==
            prov.features[feature].properties.hc_key
          ) {
            this.data_provinsi.push({
              nama_provinsi: prov.features[feature].properties.name,
              count: this.dataset[data].z,
            });
          }
        }
      }
      this.data_provinsi.sort(function(a, b) {
        return b.count - a.count;
      });

      for (let i = 0; i < 10; i++) {
        if (this.data_provinsi[i] != null) {
          this.top_provinsi.push(this.data_provinsi[i]);
        }
      }
      this.topKey++;
    },
    getDataExcel: function() {
      this.$store.dispatch("loading", true);
      var topik = XLSX.utils.json_to_sheet(this.data_provinsi);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, topik, "Maps");
      XLSX.writeFile(wb, "Maps.xlsx");
      this.$store.dispatch("loading", false);
    },
    thousandSeparator(value) {
      return gp.thousandSeparator(value);
    },
  },
  filters: {
    date_time_to_indo: function(tanggal) {
      return gp.dateTimeID(tanggal);
    },
  },
  watch: {
    $route() {
      if ("page" in this.$route.query && "province" in this.$route.query) {
        this.getPost(this.$route.query.province);
      }
    },
  },
  created: function() {
    this.getTopic();
  },
  mounted: function() {
    this.mounted = true;
    let self = this;
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $("body").offset().top,
      },
      1000
    );
    $("#popular-account").on("click", ".source-akun-clicked", function(e) {
      e.preventDefault();
      let index = $(this).attr("data-index");
      self.showPost(index);
    });

    let v_step = [];
    v_step[0] = {
      target: "#page-header-validasi",
      header: {
        title: "Filter Validasi",
      },
      content: `Digunakan untuk memfilter data berdasarkan status validasi`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#page-header-select",
      header: {
        title: "Filter Topik",
      },
      content: `Digunakan untuk memfilter data berdasarkan topik`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#reportrange",
      header: {
        title: "Filter Periode",
      },
      content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#tab",
      header: {
        title: "Berpindah Tab",
      },
      content: `Anda dapat berpindah tab dengan melakukan klik pada media konvensional atau media sosial.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#mapcontainer",
      header: {
        title: "Peta Sebaran Pengguna Twitter",
      },
      content:
        "Jumlah postingan disetiap provinsi direpresentasikan oleh bulatan pada peta. Semakin besar bulatannya menunjukan semakin banyak postingan dari provinsi tersebut. Anda dapat melakukan klik pada bulatan provinsi untuk melihat detail postingan dan akun pada provinsi tersebut.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#top-provinsi",
      header: {
        title: "Top 10 Provinsi",
      },
      content:
        "Menampilkan daftar 10 provinsi dengan mention terbanyak dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[6] = {
      target: "#popular-account",
      header: {
        title: "Akun Terpopuler",
      },
      content:
        "Akan menampilkan daftar akun terpopuler di kota yang dipilih dengan jumlah berita yang di posting dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[7] = {
      target: "#unggahan-terbaru",
      header: {
        title: "Unggahan Terbaru",
      },
      content:
        "Akan menampilkan unggahan terbaru di kota yang dipilih dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    this.tour_steps = v_step;
  },
};
</script>

<style scoped>
.provinsiFloat {
  position: relative;
  z-index: 1;
}
.provinsiFloat .cardFloat {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 300px;
  box-shadow: rgba(100, 100, 111, 0.478) 0px 7px 29px 0px;
  padding: 8.5px;
}
.col-md-25 {
  width: 20% !important;
}
</style>
